import React, {Component} from 'react'

import Site, {SiteModifier_} from '../../utils/Site';



class Toggle extends Component {

  active = false;
  constructor(){

      super();
     

  }
  componentDidMount = () => {

      let el = (this.props.for) ? document.querySelector(this.props.for) : this.refs.el;
      let className= (this.active) ? 'is-active' : 'is-inactive';
      el.classList.add(className);

  }
  click = () => {

      
      let el = (this.props.for) ? document.querySelector(this.props.for) : this.refs.el;

      this.active = !this.active;

      el.classList.toggle("is-active");
      el.classList.toggle("is-inactive");

  }
  render () {

    let content = null;

    let Tag = (this.props.tag || "a");

   return (<Tag ref={'el'} onClick={this.click} className={this.props.className}>{this.props.children}</Tag>)
      
  }
   
}

export default Toggle



// WEBPACK FOOTER //
// ./src/js/_core/components/Toggle/Toggle.jsx